import { API_PALLAS_APPS_URL } from "../ducks/consts";

const post = (path, body) =>
  fetch(`${API_PALLAS_APPS_URL}${path}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

// NOVO = ainda não tem cadastro, OK = tem senha, SEM_SENHA = cliente antigo
// (ou cadastro interrompido) que precisa criar senha com código por SMS.
export async function userStatus(phone) {
  return await post("/user/status", { telefone: phone });
}

export async function registerUser(name, phone, birthday, password) {
  return await post("/user/register", {
    nome: name,
    telefone: phone,
    nascido_em: birthday,
    senha: password,
  });
}

export async function signIn(phone, password) {
  return await post("/user/signIn", { telefone: phone, senha: password });
}

// Único caminho que gasta mensagem: criar a primeira senha e esqueci a senha.
export async function sendResetCode(phone) {
  return await post("/user/sendResetCode", { telefone: phone });
}

// Confere o código sem queimá-lo: a tela pede o código num passo e a senha no
// seguinte, e quem consome o código é o setPassword.
export async function checkCode(userId, code) {
  return await post("/user/checkCode", { appUserId: userId, code });
}

export async function setPassword(userId, code, password) {
  return await post("/user/setPassword", {
    appUserId: userId,
    code,
    senha: password,
  });
}

export async function getValidOrders(userId, userUuid, storeId) {
  return await post("/user/points", {
    appUserId: userId,
    uuid: userUuid,
    lojaId: storeId,
  });
}

// Erro do loopback: { error: { statusCode, message, code } }. As mensagens da
// API já vêm prontas para o cliente ler (limite de envio, senha curta, etc).
export function apiError(response, fallback) {
  const error = new Error(response?.error?.message || fallback);
  error.statusCode = response?.error?.statusCode;
  error.code = response?.error?.code;
  return error;
}

// Falha de rede não tem statusCode e traz mensagem técnica ("Failed to fetch").
export function errorMessage(error, fallback) {
  return error.statusCode ? error.message : fallback;
}
